// extracted by mini-css-extract-plugin
export default {"post_details":"PostDetails_post_details__zQZuA","tags":"PostDetails_tags__8SRNa","createdby":"PostDetails_createdby__7MTW2"};